var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 140,
    viewBox: "0 0 139 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.283 70C138.283 108.66 107.487 140 69.4999 140C31.5123 140 0.717285 108.66 0.717285 70C0.717285 31.3401 31.5123 0 69.4999 0C107.487 0 138.283 31.3401 138.283 70Z",
    fill: "url(#paint0_radial_2105_29940)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6769 101.094C55.0146 101.64 54.8911 102.04 54.8911 102.26H51.8477C51.8477 100.868 52.661 99.7297 53.6928 98.8781C54.7295 98.0224 56.1407 97.3181 57.7521 96.7555C60.9876 95.6261 65.3564 94.9561 70.1085 94.9561C74.8606 94.9561 79.2295 95.6261 82.4649 96.7555C84.0764 97.3181 85.4875 98.0224 86.5243 98.8781C87.5561 99.7297 88.3694 100.868 88.3694 102.26H85.3259C85.3259 102.04 85.2024 101.64 84.5402 101.094C83.8828 100.551 82.8426 99.9963 81.4248 99.5014C78.6019 98.5159 74.6012 97.8778 70.1085 97.8778C65.6159 97.8778 61.6152 98.5159 58.7922 99.5014C57.3745 99.9963 56.3343 100.551 55.6769 101.094Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7038 38.5873C37.7574 36.7796 37.746 35.5786 37.3322 34.9929L39.0354 33.7897C40.2088 35.4505 39.6385 37.6933 38.5055 39.6374C37.3211 41.6695 35.2991 43.8038 32.7439 45.609C30.1887 47.4141 27.5014 48.6068 25.1904 49.044C22.9795 49.4624 20.6751 49.2505 19.5017 47.5896L21.2049 46.3864C21.6187 46.9721 22.7468 47.3841 24.8027 46.9951C26.7584 46.625 29.1721 45.5791 31.5407 43.9058C33.9092 42.2325 35.7015 40.307 36.7038 38.5873Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2105_29940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3693 66.3481C60.3693 76.7695 51.9211 85.2176 41.4997 85.2176C31.0783 85.2176 22.6301 76.7695 22.6301 66.3481C22.6301 55.9267 31.0783 47.4785 41.4997 47.4785C51.9211 47.4785 60.3693 55.9267 60.3693 66.3481Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.498 55.2871C53.692 58.8433 49.975 66.8813 42.8627 69.2692C35.7503 71.657 27.9359 67.4903 26.742 63.9342C25.5481 60.378 28.447 53.777 36.4958 51.0748C44.5446 48.3726 51.3041 51.731 52.498 55.2871Z",
    fill: "#FBF2C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.829 72.6011C49.3015 74.0341 47.9421 75.7704 45.7925 76.4792C43.643 77.188 41.5174 76.601 41.0448 75.168C40.5723 73.7349 41.9317 71.9986 44.0813 71.2898C46.2308 70.581 48.3564 71.1681 48.829 72.6011Z",
    fill: "#FBF2C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.819 38.5864C99.7653 36.7786 99.7767 35.5776 100.19 34.9919L98.4873 33.7887C97.314 35.4496 97.8842 37.6924 99.0172 39.6364C100.202 41.6685 102.224 43.8028 104.779 45.608C107.334 47.4132 110.021 48.6058 112.332 49.0431C114.543 49.4614 116.848 49.2495 118.021 47.5886L116.318 46.3854C115.904 46.9711 114.776 47.3831 112.72 46.9941C110.764 46.6241 108.351 45.5781 105.982 43.9048C103.614 42.2315 101.821 40.306 100.819 38.5864Z",
    fill: "black"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2105_29940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.152 66.3481C115.152 76.7695 106.704 85.2176 96.2824 85.2176C85.861 85.2176 77.4128 76.7695 77.4128 66.3481C77.4128 55.9267 85.861 47.4785 96.2824 47.4785C106.704 47.4785 115.152 55.9267 115.152 66.3481Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.758 55.2813C107.952 58.8374 104.235 66.8755 97.1224 69.2633C90.0101 71.6511 82.1957 67.4845 81.0018 63.9283C79.8079 60.3721 82.7068 53.7711 90.7556 51.0689C98.8043 48.3667 105.564 51.7251 106.758 55.2813Z",
    fill: "#FBF2C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.094 72.5972C103.566 74.0302 102.207 75.7665 100.057 76.4753C97.9077 77.1841 95.782 76.5971 95.3095 75.164C94.8369 73.731 96.1964 71.9947 98.3459 71.2859C100.495 70.5771 102.621 71.1641 103.094 72.5972Z",
    fill: "#FBF2C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2105_29940",
    x: 20.6301,
    y: 45.4785,
    width: 41.739,
    height: 41.7393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2105_29940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2105_29940",
    x: 75.4128,
    y: 45.4785,
    width: 41.739,
    height: 41.7393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2105_29940"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2105_29940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.4999 70) rotate(90) scale(70 68.7826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F7CFDA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.30416734211e08335bf9bedb623a15e2.svg";
export { ForwardRef as ReactComponent };